import React from 'react';
import { useGame } from '../../contexts/GameContext.tsx';
import GameCell from './GameCell.tsx';

interface SosCombo {
  coords: number[][];
  direction: 'horizontal' | 'vertical' | 'diagonal-right' | 'diagonal-left';
}

interface GameBoardProps {
  onCellClick: (row: number, col: number) => Promise<void>;
  roomId: string | undefined;
  sosCombos: SosCombo[];
}

const GameBoard: React.FC<GameBoardProps> = ({ onCellClick, roomId, sosCombos }) => {
  const { state } = useGame();
  const { board, currentPlayer, gameStatus } = state; 

  // Yardımcı: Bu hücre bir SOS kombinasyonunda mı ve yönü ne?
  // const getSosInfo = (row: number, col: number) => {
  //   for (const combo of sosCombos) {
  //     if (combo.coords.some(([r, c]) => r === row && c === col)) {
  //       return { isSos: true, direction: combo.direction };
  //     }
  //   }
  //   return { isSos: false, direction: undefined };
  // };


  const getSosDirections = (row: number, col: number): ('horizontal' | 'vertical' | 'diagonal-right' | 'diagonal-left')[] => {
    const directions: ('horizontal' | 'vertical' | 'diagonal-right' | 'diagonal-left')[] = [];
    if (!sosCombos) return directions;

    for (const combo of sosCombos) {
      if (combo.coords.some(([r, c]) => r === row && c === col)) {
        directions.push(combo.direction);
      }
    }
    return directions;
  };

  if (!Array.isArray(board) || board.length === 0) {
    return <div>Loading game board...</div>;
  }

  return (
    <div className="flex flex-col items-center gap-2 w-full overflow-x-auto">
      <div className="grid grid-cols-8 gap-0.5 sm:gap-1 bg-gray-200 p-1 sm:p-2 rounded-lg min-w-[320px] sm:min-w-[416px] max-w-full">
        {board.map((row, rowIndex) =>
          (Array.isArray(row) ? row : []).map((cell, colIndex) => {

            const directions = getSosDirections(rowIndex, colIndex);

            return (
              <GameCell
                key={`${rowIndex}-${colIndex}`}
                value={cell}
                row={rowIndex}
                col={colIndex}
                disabled={gameStatus !== 'playing' || !currentPlayer}
                onCellClick={onCellClick}

                directions={directions}

              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default GameBoard; 